import { RouteInfo } from "./types";
import { authGuard, permissionGuard } from "./guards/index";
import { UIPAGE } from "@/constants/ui-page.constants";

const ViewCoverageSearch = () => import(/* webpackChunkName: "chunk-coverage-search" */ "@/views/coverage-search-v2/CoverageSearchV2.vue");

export const CoverageSearchRoute: RouteInfo = {
	id: UIPAGE.COVERAGE_SEARCH,
	path: "/coverage-search",
	component: ViewCoverageSearch,
	guards: [authGuard, permissionGuard],
	title: "coverage_search.display",
	icon: "mdi-map-search-outline"
};
